import type React from 'react';
import { cn } from '../../common/functions/cn';

const Table = ({ className, ...props }: React.ComponentProps<'table'>) => {
  return (
    <div data-slot="table-container" className="relative w-full overflow-x-auto">
      <table data-slot="table" className={cn('w-full caption-bottom text-sm', className)} {...props} />
    </div>
  );
};

const TableHeader = ({ className, ...props }: React.ComponentProps<'thead'>) => {
  return <thead data-slot="table-header" className={cn('[&_tr]:border-b', className)} {...props} />;
};

const TableBody = ({ className, ...props }: React.ComponentProps<'tbody'>) => {
  return <tbody data-slot="table-body" className={cn('[&_tr:last-child]:border-0', className)} {...props} />;
};

const TableFooter = ({ className, ...props }: React.ComponentProps<'tfoot'>) => {
  return (
    <tfoot
      data-slot="table-footer"
      className={cn('border-t bg-muted/50 font-medium [&>tr]:last:border-b-0', className)}
      {...props}
    />
  );
};

const TableRow = ({ className, ...props }: React.ComponentProps<'tr'>) => {
  return (
    <tr
      data-slot="table-row"
      className={cn(
        'border-b transition-colors hover:bg-muted/50 has-aria-expanded:bg-muted/50 data-[state=selected]:bg-muted',
        className
      )}
      {...props}
    />
  );
};

const TableHead = ({ className, ...props }: React.ComponentProps<'th'>) => {
  return (
    <th
      data-slot="table-head"
      className={cn('h-10 whitespace-nowrap px-2 text-left align-middle font-medium text-foreground', className)}
      {...props}
    />
  );
};

const TableCell = ({ className, ...props }: React.ComponentProps<'td'>) => {
  return <td data-slot="table-cell" className={cn('whitespace-nowrap p-2 align-middle', className)} {...props} />;
};

const TableCaption = ({ className, ...props }: React.ComponentProps<'caption'>) => {
  return (
    <caption data-slot="table-caption" className={cn('mt-4 text-muted-foreground text-sm', className)} {...props} />
  );
};

export { Table, TableBody, TableCaption, TableCell, TableFooter, TableHead, TableHeader, TableRow };
